// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6NewForm from "../../randing/RandingStyle6NewForm";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing102({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/102/20250220_01.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/102/20250220_02.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/102/20250220_04.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/102/20250220_03.gif`}
      formFieldColor="white"
      qOptions={["1~4개", "5개 이상", "전체", "상담필요"]}
      qOptionColor="blue"
      questionType="btn"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/costBenefitButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing102;
